// PATH: src/sites/realstate/components/layout/AppLayout/AppLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "sites/realstate/components/layout/Navbar";
import Footer from "sites/realstate/components/layout/Footer";

export default function AppLayout() {
    return (
        <>
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
}
